function createHiddenInput(name, value) {
  var input = document.createElement('input');
  input.type = 'hidden';
  input.name = name;
  input.value = value;
  return input;
}

if (!window._ffColorBubblesInit) {
  window._ffColorBubblesInit = true;

  document.querySelectorAll('.ff-product-card__color-bubbles').forEach(function(container) {
    var card = container.closest('.ff-product-card');
    if (card) {
      card.classList.add('ff-product-card--has-bubbles');
      card.dataset.tryInStoreText = container.dataset.tryInStoreText || '';
      card.dataset.notifyMeText = container.dataset.notifyMeText || '';
      card.dataset.comingSoonText = container.dataset.comingSoonText || '';
    }
  });

  let activeBubble = null;

  document.addEventListener('mouseover', (e) => {
    const bubble = e.target.closest('.ff-product-card__color-bubbles .color-bubble[data-product-url]');
    if (!bubble) return;
    if (bubble === activeBubble) return;
    activeBubble = bubble;

    const card = bubble.closest('.ff-product-card');
    if (!card) return;

    const img = card.querySelector('.ff-product-card__image-wrapper img:not(.ff-product-card__image--secondary img)');
    const title = card.querySelector('.ff-product-card__title');
    const atcBtn = card.querySelector('.ff-product-card__atc-button');

    const comingSoon = card.querySelector('.ff-product-card__coming-soon');

    if (!card.dataset.originalUrl) {
      card.dataset.originalUrl = card.getAttribute('href');
      card.dataset.originalTitle = title ? title.textContent : '';
      card.dataset.originalImage = img ? img.src : '';
      card.dataset.originalSrcset = img ? img.srcset : '';
      if (atcBtn) {
        card.dataset.originalVariantId = atcBtn.dataset.variantId;
        card.dataset.originalAtcText = atcBtn.textContent.trim();
      }
      card.dataset.originalAvailability = comingSoon ? 'unavailable' : 'available';
    }

    const availability = bubble.dataset.availability || 'available';

    card.setAttribute('href', bubble.dataset.productUrl);
    if (title) title.textContent = bubble.dataset.productTitle;
    if (img) {
      img.src = bubble.dataset.productImage;
      img.srcset = '';
    }
    if (atcBtn && bubble.dataset.variantId) {
      atcBtn.dataset.variantId = bubble.dataset.variantId;
      if (bubble.dataset.productId) atcBtn.dataset.productId = bubble.dataset.productId;
      if (bubble.dataset.productType) atcBtn.dataset.productType = bubble.dataset.productType;
    }

    if (atcBtn) {
      if (availability === 'available') {
        atcBtn.textContent = card.dataset.tryInStoreText || 'Add to cart';
      } else {
        atcBtn.textContent = card.dataset.notifyMeText || 'Notify me';
      }
    }

    if (availability !== 'available') {
      if (!comingSoon) {
        const cs = document.createElement('div');
        cs.className = 'ff-product-card__coming-soon';
        cs.textContent = card.dataset.comingSoonText || 'COMING SOON';
        const titleEl = card.querySelector('.ff-product-card__title');
        if (titleEl) titleEl.parentNode.insertBefore(cs, titleEl);
      }
    } else {
      if (comingSoon) comingSoon.remove();
    }

    bubble.closest('.ff-product-card__color-bubbles')
      .querySelectorAll('.color-bubble')
      .forEach(function(b) { b.classList.remove('is-active'); });
    bubble.classList.add('is-active');
  });

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.ff-product-card__atc-button');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const card = btn.closest('.ff-product-card');
    const notifyMeText = card ? card.dataset.notifyMeText : '';
    if (notifyMeText && btn.textContent.trim() === notifyMeText.trim()) {
      const title = card.querySelector('.ff-product-card__title');
      const productTitle = title ? title.textContent.trim() : '';
      const productUrl = card ? card.getAttribute('href') : '';
      if (window.ffNotifyMeOpen) {
        window.ffNotifyMeOpen(productTitle, productUrl);
      }
      return;
    }

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    if (window.ffCartLimits) {
      var productId = btn.dataset.productId;
      var productType = btn.dataset.productType || '';
      if (productId && window.ffCartLimits.isProductInCart(productId)) {
        window.ffCartLimits.showLimitPopup();
        return;
      }
      if (!window.ffCartLimits.canAddProduct(productType)) {
        window.ffCartLimits.showLimitPopup();
        return;
      }
    }

    btn.disabled = true;
    btn.textContent = '...';

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    var tempForm = document.createElement('form');
    tempForm.appendChild(createHiddenInput('id', variantId));
    tempForm.appendChild(createHiddenInput('quantity', '1'));

    var source = {
      ffCartLoading: function() {},
      ffCartUpdated: function() {
        btn.textContent = '\u2713';
        var cartDrawer = document.querySelector('#ff-cart-drawer');
        if (cartDrawer && cartDrawer.ffOpen) cartDrawer.ffOpen();
        if (window.ffCartLimits) window.ffCartLimits.refresh();
        setTimeout(function() {
          btn.disabled = false;
          btn.textContent = btn.dataset.originalText || 'Add to cart';
          if (window.ffCartLimits) window.ffCartLimits.refresh();
        }, 1500);
      },
      ffCartError: function() {
        btn.disabled = false;
        btn.textContent = btn.dataset.originalText || 'Add to cart';
      }
    };

    if (typeof FfCartService !== 'undefined') {
      FfCartService.add(tempForm, { source: source, startFresh: true });
    } else {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
      })
      .then(function(res) {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(function() { source.ffCartUpdated(); })
      .catch(function() { source.ffCartError(); });
    }
  });

  document.querySelectorAll('.ff-product-card__atc-button').forEach(function(btn) {
    btn.dataset.originalText = btn.textContent.trim();
  });
}
